/**
 * @flow
 * @relayHash d527ac998466f73b284760efe3e5f40a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Http5xxErrorsTable_project$ref = any;
export type httpStatus_HttpStatusCategory_Http5xxErrorsTable_QueryVariables = {|
  host: string
|};
export type httpStatus_HttpStatusCategory_Http5xxErrorsTable_QueryResponse = {|
  +project: ?{|
    +$fragmentRefs: Http5xxErrorsTable_project$ref
  |}
|};
export type httpStatus_HttpStatusCategory_Http5xxErrorsTable_Query = {|
  variables: httpStatus_HttpStatusCategory_Http5xxErrorsTable_QueryVariables,
  response: httpStatus_HttpStatusCategory_Http5xxErrorsTable_QueryResponse,
|};
*/


/*
query httpStatus_HttpStatusCategory_Http5xxErrorsTable_Query(
  $host: String!
) {
  project(host: $host) {
    ...Http5xxErrorsTable_project
    id
  }
}

fragment Http5xxErrorsTable_project on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        countCodesHttp5xxErrors(sourceUrl: {operator: AND, values: []}, errorUrl: {operator: AND, values: []}, linkTypeFilter: {showInternal: true, showExternal: true}) {
          code
          count
        }
        http5xxErrors(offset: 0, limit: 20, codeFilters: [], linkTypeFilter: {showInternal: true, showExternal: true}, errorUrl: {operator: AND, values: []}, sourceUrl: {operator: AND, values: []}) {
          count
          edges {
            node {
              ...Http5xxErrorsRow_issue
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment Http5xxErrorsRow_issue on Http5xxError {
  id
  type
  severity
  code
  internal
  error_url
  source_url
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "Literal",
  "name": "offset",
  "value": 0,
  "type": "Int"
},
v3 = {
  "operator": "AND",
  "values": ([]/*: any*/)
},
v4 = {
  "kind": "Literal",
  "name": "errorUrl",
  "value": v3,
  "type": "TextFilters"
},
v5 = {
  "kind": "Literal",
  "name": "linkTypeFilter",
  "value": {
    "showExternal": true,
    "showInternal": true
  },
  "type": "LinkTypeFilter"
},
v6 = {
  "kind": "Literal",
  "name": "sourceUrl",
  "value": v3,
  "type": "TextFilters"
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "httpStatus_HttpStatusCategory_Http5xxErrorsTable_Query",
  "id": null,
  "text": "query httpStatus_HttpStatusCategory_Http5xxErrorsTable_Query(\n  $host: String!\n) {\n  project(host: $host) {\n    ...Http5xxErrorsTable_project\n    id\n  }\n}\n\nfragment Http5xxErrorsTable_project on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        countCodesHttp5xxErrors(sourceUrl: {operator: AND, values: []}, errorUrl: {operator: AND, values: []}, linkTypeFilter: {showInternal: true, showExternal: true}) {\n          code\n          count\n        }\n        http5xxErrors(offset: 0, limit: 20, codeFilters: [], linkTypeFilter: {showInternal: true, showExternal: true}, errorUrl: {operator: AND, values: []}, sourceUrl: {operator: AND, values: []}) {\n          count\n          edges {\n            node {\n              ...Http5xxErrorsRow_issue\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment Http5xxErrorsRow_issue on Http5xxError {\n  id\n  type\n  severity\n  code\n  internal\n  error_url\n  source_url\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "httpStatus_HttpStatusCategory_Http5xxErrorsTable_Query",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Http5xxErrorsTable_project",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "httpStatus_HttpStatusCategory_Http5xxErrorsTable_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              v2
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "countCodesHttp5xxErrors",
                        "storageKey": "countCodesHttp5xxErrors(errorUrl:{\"operator\":\"AND\",\"values\":[]},linkTypeFilter:{\"showExternal\":true,\"showInternal\":true},sourceUrl:{\"operator\":\"AND\",\"values\":[]})",
                        "args": [
                          v4,
                          v5,
                          v6
                        ],
                        "concreteType": "CountCode",
                        "plural": true,
                        "selections": [
                          v7,
                          v8
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "http5xxErrors",
                        "storageKey": "http5xxErrors(codeFilters:[],errorUrl:{\"operator\":\"AND\",\"values\":[]},limit:20,linkTypeFilter:{\"showExternal\":true,\"showInternal\":true},offset:0,sourceUrl:{\"operator\":\"AND\",\"values\":[]})",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "codeFilters",
                            "value": [],
                            "type": "[Int]"
                          },
                          v4,
                          {
                            "kind": "Literal",
                            "name": "limit",
                            "value": 20,
                            "type": "Int"
                          },
                          v5,
                          v2,
                          v6
                        ],
                        "concreteType": "Http5xxErrorConnection",
                        "plural": false,
                        "selections": [
                          v8,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Http5xxErrorEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Http5xxError",
                                "plural": false,
                                "selections": [
                                  v9,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "type",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "severity",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  v7,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "internal",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "error_url",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "source_url",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v9
                    ]
                  }
                ]
              }
            ]
          },
          v9
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7a6bad774ea81278934188e428c88b58';
module.exports = node;
